/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { useMatches } from '@tanstack/react-router'

/** True when any matched route sets `staticData.disableSeasonalTheme`. */
export const useDisableSeasonalTheme = (): boolean => {
  const matches = useMatches()
  return matches.some((match) => match.staticData?.disableSeasonalTheme)
}
